import React from "react";
 
/**
 * Dark rounded screen-style frame (same as the website screenshots).
 * tag  -> small teal label on top-left of the image (optional)
 * size -> "lg" (intro / detail) | "md" (capability rows)
 */
const ImageFrame = ({ src, alt, tag, size = "md" }) => (
  <div className={`gp-frame gp-frame--${size}`}>
    <div className="gp-frame__inner">
      {tag && <span className="gp-frame__tag">{tag}</span>}
      <img src={src} alt={alt} loading="lazy" className="gp-frame__img" />
    </div>
  </div>
);
 
export default ImageFrame;
 